import locale from "@bonliva-crm/locale";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, Typography, useTheme } from "@material-ui/core";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

type Props = CustomCellRendererProps<ConsultantRowData>;

export function ReferenceSwedenRenderer(props: Props) {
  const theme = useTheme();

  const qc = props.data?.qualityChecks?.find(
    (x) => x.country === "Sweden" && x.itemName === "Referenser"
  );

  const bgColor = qc?.status === "Approved" ? theme.palette.success.light : undefined;

  return (
    <Box
      style={{ backgroundColor: bgColor }}
      height="100%"
      width="100%"
      p={0.5}
      display={"flex"}
      alignItems={"center"}
    >
      <Typography display="inline" variant="body2">
        {qc?.status ? locale.searchQualityCheckStatus[qc?.status] : null}
      </Typography>
    </Box>
  );
}
